<template>
  <!-- VISTA LISTAR -->
  <div>
    <template v-if="view === 'listar'">
        <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
          :custom-create-actions="[listTipoPersona, listTipoDoc, listEntidadesEmisoras]" @updateValues="setupUpdateValues">
          <div class="flex flex-wrap gap-3 w-full sm:w-auto">
            <component :is="childHeaderComponent" :mainListCollectionData="mainListCollectionData" :refreshData = "refreshData" :auth-token="authToken"></component>
          </div>
          <button @click="downloadReport()" class="px-4 py-2 text-white bg-yellow-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-yellow-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
          </svg>
        <span class="ml-3">Descargar informe</span>
      </button>
        </HeaderComponent>
      <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
        @updateValues="setupUpdateValues">
      </FilterRefactComponent>

      <TableComponent :entity="entity" :selected-data="selectedEmbargo" :table-columns="tableColumns"
        :collection-data="collectionData" :custom-update-actions="[listTipoPersona, listTipoDoc, listEntidadesEmisoras]"
        :custom-update-selected-data="customUpdateSelectedData" :auth-token="authToken" :list-api="listApi"
        :custom-update-collection-data="customUpdateCollectionData"
        @updateValues="setupUpdateValues">
        
          <template v-slot="{ data }">

            <!-- Mostrar el botón de Notificar solo si es pensionado o empleado -->
            <component 
              v-if="data.demandado.tipoPersona.nombre != 'Contratista'"
              :is="childTableComponent" 
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component>

            <component
              :is="childLiquidarTableComponent"
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de egresos-->
            <!-- <component 
              :is="childEgresoTableComponent" 
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component> -->

            <!-- Mostrar el botón de liquidar, solo para contratistas -->
            <component 
              :is="childExitosoTableComponent" 
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component>
    
            <!-- Mostrar el botón de levantar medida -->
            <component 
              :is="childLevantarTableComponent" 
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de cargar soportes -->
            <component 
              :is="childSoportesTableComponent" 
              :data="data" 
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } " 
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de Observaciones -->
            <component
              :is="childObservacionesTableComponent"
              :data="data"
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } "
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de Oficios (R1) -->
            <component
              :is="childOficiosTableComponent"
              :data="data"
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } "
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de Comprobantes SIIAF cuenta puente (R4) -->
            <component
              :is="childComprobanteSiiafTableComponent"
              :data="data"
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } "
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de Reintegros (R9) -->
            <component
              :is="childReintegroTableComponent"
              :data="data"
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } "
              @updateValues="setupUpdateValues"
            ></component>

            <!-- Mostrar el botón de Notificación a Asuntos Jurídicos (R6) -->
            <component
              :is="childNotificarJuridicaTableComponent"
              :data="data"
              :view="view"
              @data="(newData) => {
                updateValues({ data: newData }, this)
              } "
              @updateValues="setupUpdateValues"
            ></component>

          </template>

      </TableComponent>

      <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
        @updateValues="setupUpdateValues">
      </PaginateRefactComponent>
    </template>

    <template v-else-if="view === 'notificar_embargo'">
      <component :is="childNotificarEmbargoComponent" :load-data="loadDataEmbargo"
        :custom-update-value-data="customUpdateValueData" :data="data" :auth-token="authToken"
        :entity="{ gender: 'f', value: 'notificación de embargo' }" @updateValues="setupUpdateValues"
        :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'liquidar_embargo'">
      <component :is="childLiquidarEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'f', value: 'Liquidación de embargo' }"
        @updateValues="setupUpdateValues" @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'egreso_embargo'">
      <component :is="childEgresoEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Egreso de embargo' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'exitoso_embargo'">
      <component :is="childExitosoEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Exitoso de embargo' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'levantar_embargo'">
      <component :is="childLevantarEmbargoComponent" :load-data="loadDataEmbargo"
        :custom-update-value-data="customUpdateValueData" :data="data" :auth-token="authToken"
        :entity="{ gender: 'm', value: 'levantamiento de embargo' }" @updateValues="setupUpdateValues"
        :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'observaciones_embargo'">
      <component :is="childObservacionesEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'f', value: 'Observación' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'soportes_embargo'">
      <component :is="childSoportesEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Soporte' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'oficios_embargo'">
      <component :is="childOficiosEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Oficio' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'comprobantes_siiaf_embargo'">
      <component :is="childComprobanteSiiafEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Comprobante SIIAF' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'reintegro_embargo'">
      <component :is="childReintegroEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'm', value: 'Reintegro' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <template v-else-if="view === 'notificar_juridica_embargo'">
      <component :is="childNotificarJuridicaEmbargoComponent" :custom-update-value-data="customUpdateValueData" :data="data"
        :auth-token="authToken" :entity="{ gender: 'f', value: 'Notificación a Asuntos Jurídicos' }" @updateValues="setupUpdateValues"
        @watchList="listData" :customSaveData="customSaveData">
      </component>
    </template>

    <!-- VISTA CREAR - ACTUALIZAR -->
    <template v-else>
      <CreateUpdateComponent :view="view" :paginate="paginate" :load-data="loadDataEmbargo" :selected-data="selectedEmbargo" :entity="entity"
        :auth-token="authToken" :list-api="listApi" :queries="queries" :custom-update-load-data="customUpdateLoadData"
        @updateValues="setupUpdateValues" >
        <component :is="childFormComponent" :load-data="loadDataEmbargo" :view="view" :custom-update-value-data="customUpdateValueData"
          :collection-tipo-persona="collectionTipoPersona"
          :collection-tipo-doc="collectionTipoDoc"
          :collection-entidades-emisoras="collectionEntidadesEmisoras"
          @updateValues="setupUpdateValues">
        </component>

      </CreateUpdateComponent>
    </template>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import { useLayoutMain, updateValues, listCollectionData } from "@/layouts/main";
import BotonNotificarEmbargoPersonaComponent from "@/components/embargos/components/BotonNotificarEmbargoPersonaComponent.vue";
import ChildHeaderComponent from "@/components/embargos/components/EmbargosPersonasCargueMasivoComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import EmbargosPersonaCrearActualizarComponent from "@/components/embargos/components/EmbargosPersonaCrearActualizarComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import TableComponent from "@/layouts/main/TableComponent";
import NotificarEmbargoPersonaComponent from '@/components/embargos/components/NotificarEmbargoPersonaComponent'
import BotonLiquidarEmbargoPersonaComponent from '@/components/embargos/components/BotonLiquidarEmbargoPersonaComponent'
import LiquidacionesEmbargoPersonaComponent from '@/components/embargos/components/LiquidacionesEmbargoPersonaComponent'
import BotonEgresoEmbargoPersonaComponent from '@/components/embargos/components/BotonEgresoEmbargoPersonaComponent'
import EgresosEmbargoPersonaComponent from '@/components/embargos/components/EgresosEmbargoPersonaComponent'
import BotonExitosoEmbargoPersonaComponent from '@/components/embargos/components/BotonExitosoEmbargoPersonaComponent'
import ExitososEmbargoPersonaComponent from '@/components/embargos/components/ExitososEmbargoPersonaComponent'
import BotonLevantamientoEmbargoGobernacionComponent from '@/components/embargos/components/BotonLevantamientoEmbargoGobernacionComponent'
import LevantarEmbargoPersonasComponent from '@/components/embargos/components/LevantarEmbargoPersonasComponent'
import BotonSoportesEmbargoPersonaComponent from '@/components/embargos/components/BotonSoportesEmbargoPersonaComponent'
import BotonObservacionesEmbargoPersonaComponent from '@/components/embargos/components/BotonObservacionesEmbargoPersonaComponent'
import SoportesEmbargoPersonaComponent from '@/components/embargos/components/SoportesEmbargoPersonaComponent';
import ObservacionesEmbargoPersonasComponent from "@/components/embargos/components/ObservacionesEmbargoPersonasComponent";
import BotonOficiosEmbargoPersonaComponent from '@/components/embargos/components/BotonOficiosEmbargoPersonaComponent'
import OficiosEmbargoPersonaComponent from '@/components/embargos/components/OficiosEmbargoPersonaComponent'
import BotonComprobanteSiiafEmbargoPersonaComponent from '@/components/embargos/components/BotonComprobanteSiiafEmbargoPersonaComponent'
import ComprobantesSiiafEmbargoPersonaComponent from '@/components/embargos/components/ComprobantesSiiafEmbargoPersonaComponent'
import BotonReintegroEmbargoPersonaComponent from '@/components/embargos/components/BotonReintegroEmbargoPersonaComponent'
import ReintegrosEmbargoPersonaComponent from '@/components/embargos/components/ReintegrosEmbargoPersonaComponent'
import BotonNotificarJuridicaEmbargoPersonaComponent from '@/components/embargos/components/BotonNotificarJuridicaEmbargoPersonaComponent'
import NotificarJuridicaEmbargoPersonaComponent from '@/components/embargos/components/NotificarJuridicaEmbargoPersonaComponent'
import { separateNumberByComma , copiaProfunda, useAPIRest  } from "@/common/constants/functions";
import { utils, writeFile } from "xlsx-js-style";

export default {
  name: 'EmbargosPersonas',
  components: {
    BotonNotificarEmbargoPersonaComponent,
    ChildHeaderComponent,
    CreateUpdateComponent,
    EmbargosPersonaCrearActualizarComponent,
    FilterRefactComponent,
    HeaderComponent,
    PaginateRefactComponent,
    TableComponent,
    NotificarEmbargoPersonaComponent,
    BotonLiquidarEmbargoPersonaComponent,
    LiquidacionesEmbargoPersonaComponent,
    BotonEgresoEmbargoPersonaComponent,
    EgresosEmbargoPersonaComponent,
    BotonExitosoEmbargoPersonaComponent,
    ExitososEmbargoPersonaComponent,
    BotonLevantamientoEmbargoGobernacionComponent,
    LevantarEmbargoPersonasComponent,
    BotonSoportesEmbargoPersonaComponent,
    BotonObservacionesEmbargoPersonaComponent,
    SoportesEmbargoPersonaComponent,
    ObservacionesEmbargoPersonasComponent,
    BotonOficiosEmbargoPersonaComponent,
    OficiosEmbargoPersonaComponent,
    BotonComprobanteSiiafEmbargoPersonaComponent,
    ComprobantesSiiafEmbargoPersonaComponent,
    BotonReintegroEmbargoPersonaComponent,
    ReintegrosEmbargoPersonaComponent,
    BotonNotificarJuridicaEmbargoPersonaComponent,
    NotificarJuridicaEmbargoPersonaComponent,
  },
  data: function () {
    return {
      dateRangePicker: undefined,
      childFormComponent: 'EmbargosPersonaCrearActualizarComponent',
      childHeaderComponent: 'childHeaderComponent',
      childTableComponent: 'BotonNotificarEmbargoPersonaComponent',
      childNotificarEmbargoComponent: 'NotificarEmbargoPersonaComponent',
      childLiquidarTableComponent: 'BotonLiquidarEmbargoPersonaComponent',
      childLiquidarEmbargoComponent: 'LiquidacionesEmbargoPersonaComponent',
      childEgresoTableComponent: 'BotonEgresoEmbargoPersonaComponent',
      childEgresoEmbargoComponent: 'EgresosEmbargoPersonaComponent',
      childExitosoTableComponent: 'BotonExitosoEmbargoPersonaComponent',
      childExitosoEmbargoComponent: 'ExitososEmbargoPersonaComponent',
      childLevantarTableComponent: 'BotonLevantamientoEmbargoGobernacionComponent',
      childLevantarEmbargoComponent: 'LevantarEmbargoPersonasComponent',
      childSoportesTableComponent: 'BotonSoportesEmbargoPersonaComponent',
      childObservacionesTableComponent: 'BotonObservacionesEmbargoPersonaComponent',
      childSoportesEmbargoComponent: 'SoportesEmbargoPersonaComponent',
      childObservacionesEmbargoComponent: 'ObservacionesEmbargoPersonasComponent',
      childOficiosTableComponent: 'BotonOficiosEmbargoPersonaComponent',
      childOficiosEmbargoComponent: 'OficiosEmbargoPersonaComponent',
      childComprobanteSiiafTableComponent: 'BotonComprobanteSiiafEmbargoPersonaComponent',
      childComprobanteSiiafEmbargoComponent: 'ComprobantesSiiafEmbargoPersonaComponent',
      childReintegroTableComponent: 'BotonReintegroEmbargoPersonaComponent',
      childReintegroEmbargoComponent: 'ReintegrosEmbargoPersonaComponent',
      childNotificarJuridicaTableComponent: 'BotonNotificarJuridicaEmbargoPersonaComponent',
      childNotificarJuridicaEmbargoComponent: 'NotificarJuridicaEmbargoPersonaComponent',

      console: console,
      entity: { gender: 'm', value: 'Embargo' },
      Object: Object,
      title: 'Embargos contra empleados, pensionados y contratistas',
      updateValues: updateValues,
      tableColumns: {
        'numero_proceso': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número Proceso'
        },
        'entidadEmisora.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Entidad Emisora'
        },
        'numero_oficio': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Número Oficio'
        },
        'fecha_oficio': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha Oficio'
        },
        'demandado.tipoPersona.nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tipo Persona',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandado.primer_nombre' : {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Nombre Demandado',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandado.primer_apellido' : {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Apellido Demandado',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandado.identificacion': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Identificación Demandado',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandante.primer_nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Nombre Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'demandante.primer_apellido': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Primer Apellido Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
       
        'demandante.identificacion': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Identificación Demandante',
          // customCriterion: 'embargos.contratistas.identificacion'
        },
        'valor_inicial': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Valor Inicial',
          // customCallbackClassValue: (value) => parseInt(value) > 0 ? 'text-red-500 font-extrabold	' : 'text-sky-500 font-extrabold	',
        },
        'valor_actual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Saldo Actual',
          customCallbackClassValue: (value) => parseInt(value) > 0 ? 'text-red-500 font-extrabold	' : 'text-sky-500 font-extrabold	',
        },
        'estado_registro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Estado Registro',
          customCallbackClassValue: (value) => (value === 'borrador' || value === 'Incompleto') ? 'text-yellow-500 font-extrabold	' : 'text-green-500 font-extrabold	',
        },
        'alertas_documentales': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'Alertas',
          customCallbackClassValue: (value) => (value && value !== 'Sin alertas') ? 'text-red-500 font-bold' : 'text-green-500',
        },
        'pendiente_por_legalizar': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'Pendiente por Legalizar',
          customCallbackClassValue: (value) => parseFloat(String(value).replaceAll(',', '')) > 0 ? 'text-red-500 font-extrabold	' : 'text-sky-500 font-extrabold	',
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const dataUser = ref(localStorage.getItem('user'));
    const idUser = JSON.parse(dataUser.value);
    const view = ref('listar');
    const data = ref({});
    const collectionData = ref([]);
    const collectionTipoPersona = ref([]);
    const collectionTipoDoc = ref([]);
    const collectionEntidadesEmisoras = ref([]);
    const customSaveData = ref([]);
    const authToken = ref(authStored.authToken);
    
    const selectedEmbargo = ref({
      id: '',
      id_entidad_emisora: '',
      numero_oficio: '',
      fecha_oficio: '',
      primer_nombre_demandante: '',
      segundo_nombre_demandante: '',
      primer_apellido_demandante: '',
      segundo_apellido_demandante: '',
      identificacion_demandante: '',
      primer_nombre_demandado: '',
      segundo_nombre_demandado: '',
      primer_apellido_demandado: '',
      segundo_apellido_demandado: '',
      identificacion_demandado: '',
      id_demandado:'',
      numero_proceso: '',
      tipo_proceso: '',
      valor: '',
      fecha_recibido_oficio: '',
      id_tipo_persona: '',
      tipo_identificacion_demandado: '',
      tipo_identificacion_demandante: '',
      observaciones:'',
      demandante: '',
      demandado: '',
      tipoProceso: '',
      valor_inicial: '',
      valor_actual: '',
      notificaciones: '',
      levantamientos: '',
      estado_registro: '',
    });

    const customQueries = ref({ 'id_usuario': idUser.id, 'estado': 1, });

    const loadDataEmbargo = ref({
      id_entidad_emisora: '',
      numero_oficio: '',
      fecha_oficio: '',
      primer_nombre_demandante: '',
      segundo_nombre_demandante: '',
      primer_apellido_demandante: '',
      segundo_apellido_demandante: '',
      identificacion_demandante: '',
      primer_nombre_demandado: '',
      segundo_nombre_demandado: '',
      primer_apellido_demandado: '',
      segundo_apellido_demandado: '',
      identificacion_demandado: '',
      numero_proceso: '',
      tipo_proceso: '',
      valor: '',
      fecha_recibido_oficio: '',
      id_tipo_persona: '',
      id_demandado:'',
      tipo_identificacion_demandado: '',
      tipo_identificacion_demandante: '',
      observaciones:'',
      demandado: '',
      demandante: '',
      tipoProceso: '',
      valor_inicial: '',
    });

    const listApi = reactive({
      create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE,
      list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL,
      update: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATE,
      updateState: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATESTATE
    });

    const permissions = idUser.permissions;

    const customUpdateValueData = (key, value) => {
      // const fieldNumeric = ['embargo_id', 'egreso', 'identificacion', 'saldo_anterior', 'ajuste_embargo', 'reintegro', 'legalizacion', 'saldo_actual'];
      // if (fieldNumeric.includes(key)) return value !== '' ? Number(value) : value;
      return value;
    };

    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedEmbargo.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedEmbargo.value = updatedSelectedData;
    }

    const customUpdateLoadData = () => {
      for (const key in loadDataEmbargo.value) {
        let value = loadDataEmbargo.value[key];
        value = customUpdateValueData(key, value);
      }
    };

    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['valor_actual'] = separateNumberByComma(copyData['valor_actual']);
        copyData['valor_inicial'] = separateNumberByComma(copyData['valor_inicial']);
        copyData['estado_registro'] = copyData['estado_registro'] === 'borrador' ? 'Incompleto' : 'Finalizado';
        copyData['alertas_documentales'] = (Array.isArray(copyData['alertas_documentales']) && copyData['alertas_documentales'].length)
          ? copyData['alertas_documentales'].join(' | ')
          : 'Sin alertas';
        copyData['pendiente_por_legalizar'] = separateNumberByComma(copyData['pendiente_por_legalizar'] ?? 0);
      }
      return copyCollectionData;

    };

    const listTipoPersona = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPO_PERSONA, { 'collectionTipoPersona': collectionTipoPersona }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const listTipoDoc = async () => await listCollectionData(process.env.VUE_APP_NEST_TIPODOCUMENTO_FINDALL,  { 'collectionTipoDoc': collectionTipoDoc }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)

    const listEntidadesEmisoras = async () => await listCollectionData(process.env.VUE_APP_NEST_ENTIDADES_EMISORAS_FINDALL, { 'collectionEntidadesEmisoras': collectionEntidadesEmisoras }, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false)
    
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedEmbargo, loadDataEmbargo, listApi, customQueries.value);

    const refreshData = async () => {
      listData();
    }
    const listData = async () => {
      try {

        const res = await listCollectionData(
          process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL,
          { 'collectionData': collectionData.value },
          authToken.value,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
        );

        // Actualizar la referencia reactiva collectionData
        collectionData.value = res.data;

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    const updateQueries = queries.value;
    updateQueries['customQuery'] = customQueries.value;
    queries.value = updateQueries;

    const validatePermission = (permission) => {
      if (permissions.indexOf(permission) > 0) {
        return true
      }
    }

    const downloadReport = async () => {
      await useAPIRest(process.env.VUE_APP_NEST_DOWNLOAD_REPORT_EMBARGOS, 'GET', authToken.value, undefined, undefined, 'application/json').then(resp => {
        const wb = utils.book_new();
          let content = []
          let headers = [
            [
              { v: "NOMBRE DEMANDADO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "TIPO DE DOCUMENTO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "IDENTIFICACIÓN", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "TIPO DE PERSONA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "CANTIDAD EMBARGOS", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "VALOR TOTAL EMBARGOS", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "SALDO ACTUAL EMBARGOS", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "VALOR TOTAL EGRESOS", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "VALOR TOTAL LIQUIDACIONES", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
            ],
          ]
            resp.forEach(element => {
              content = [ ...content,
                [
                  { v: `${element.primer_nombre} ${element.segundo_nombre ?? ''} ${element.primer_apellido ?? ''} ${element.segundo_apellido ?? ''}` , t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.tipo_documento, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.identificacion, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.tipo_persona, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.cant_embargos, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.valor_inicial_embargos ?? '0'), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.saldo_total_embargos ?? '0'), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.total_egresos ?? '0'), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.total_liquidaciones ?? '0'), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                ],
               
              ];
            });
          const excel = headers.concat(content)
          
          const ws = utils.aoa_to_sheet(excel);

          ws['!cols'] = Array(headers[0].length).fill({ wch: 40 });

          utils.book_append_sheet(wb, ws, 'CONSOLIDADO');
          const date = Date.now();
          const fecha_doc = new Date(date)
          writeFile(wb, `Consolidado_embargo_personas_${fecha_doc.toLocaleDateString()}.xlsx`);
      })
    }

    return {
      view,
      collectionData,
      authToken,
      selectedEmbargo,
      loadDataEmbargo,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateValueData,
      customUpdateSelectedData,
      customUpdateLoadData,
      customSaveData,
      dataUser,
      data,
      customUpdateCollectionData,
      customQueries,
      permissions,
      validatePermission,
      listTipoPersona,
      collectionTipoPersona,
      listData,
      listTipoDoc,
      collectionTipoDoc,
      listEntidadesEmisoras,
      collectionEntidadesEmisoras,
      downloadReport,
      refreshData
    }

  },
}
</script>
<style scoped>
.title-embargo {
  width: 40% !important;
}
</style>